import React from 'react';
import { withTheme } from 'styled-components';

import { Svg, Line } from 'react-native-svg';

const CleanPlus = ({ className = '', theme, color = theme.colors.Foreground, size = '12px' }) => (
    <Svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
    >
        <Line x1="12" y1="6" x2="-3.86929e-08" y2="6" stroke={color} strokeWidth="2" />
        <Line x1="6" y1="12" x2="6" y2="2.02649e-07" stroke={color} strokeWidth="2" />
    </Svg>
);

export default withTheme(CleanPlus);
